(() => {
  const sortSectionByInventory = (section) => {
    if (!section || section.dataset.productSort !== 'quantity_descending') return;

    const grid = section.querySelector('.product-grid');
    if (!grid || grid.dataset.inventorySorted === 'true') return;

    const products = [...grid.querySelectorAll(':scope > li[data-inventory]')];
    if (!products.length) return;

    products.sort((a, b) => Number(b.dataset.inventory) - Number(a.dataset.inventory));

    const visibleCount = Number(section.dataset.productsToShow) || products.length;
    products.forEach((product, index) => {
      if (index >= visibleCount) {
        product.remove();
        return;
      }

      product.hidden = false;
      grid.append(product);
    });

    grid.dataset.inventorySorted = 'true';
  };

  const sortAllSections = () => {
    document.querySelectorAll('[data-product-sort="quantity_descending"]').forEach(sortSectionByInventory);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortAllSections, { once: true });
  } else {
    sortAllSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches?.('[data-product-sort]')
      ? event.target
      : event.target.querySelector?.('[data-product-sort]');
    sortSectionByInventory(section);
  });
})();
